import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [{
			path: '/:id',
			name: 'home',
			component: () => import('./views/examnew.vue')
		},
		{
			path: '/info/:id',
			name: 'info',
			component: () => import('./views/info.vue')
		},
		{
			path: '/complete/:tid',
			name: 'complete',
			component: () => import('./views/complete.vue')
		},
		{
			path: '/mobile/:tid',
			name: 'mobile',
			component: () => import('./views/mobile.vue')
		},
		{
			path: '/backlist/list',
			name: 'backlist',
			component: () => import('./views/backlist.vue')
		}
	]
})
